{
  "SET_NEW_PASSWORD": {
    "TITLE": "Set new password",
    "PASSWORD": {
      "LABEL": "Password",
      "PLACEHOLDER": "Password",
      "ERROR": "Password troppo corta."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Conferma password",
      "PLACEHOLDER": "Conferma Password",
      "ERROR": "Le password non corrispondono."
    },
    "API": {
      "SUCCESS_MESSAGE": "Password cambiata con successo.",
      "ERROR_MESSAGE": "Impossibile connettersi al server Woot. Riprova."
    },
    "CAPTCHA": {
      "ERROR": "Verifica scaduta. Si prega di risolvere nuovamente il captcha."
    },
    "SUBMIT": "Invia"
  }
}
